module.exports = __webpack_public_path__ + "images/syuccho_kaitori_lp/main-bg-pc_ddda2b8191f1cd80530de388b6246147.png";